module.exports = __webpack_public_path__ + "ceremony-3.png?9739aa65183e6037c1428bf2b6425bb3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ceremony-3.png
// module id = 283
// module chunks = 0